import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../styles/Account.css';

const TABS = [
  { to: '/account', label: 'Overview', icon: '✦', end: true },
  { to: '/account/orders', label: 'My Orders', icon: '📦' },
  { to: '/account/consultations', label: 'Consultations', icon: '🔮' },
  { to: '/account/profile', label: 'My Details', icon: '👤' },
  { to: '/account/password', label: 'Password', icon: '🔐' },
];

export default function AccountLayout() {
  const { profile, user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const displayName = profile?.full_name || user?.email || 'Welcome';

  return (
    <section className="account-page">
      <div className="account-header">
        <div>
          <p className="account-greeting">Welcome back</p>
          <h1>{displayName}</h1>
        </div>
        <button className="account-logout" onClick={handleLogout}>
          Sign Out
        </button>
      </div>

      <div className="account-body">
        <nav className="account-nav">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              className={({ isActive }) =>
                isActive ? 'account-tab active' : 'account-tab'
              }
            >
              <span className="tab-icon">{t.icon}</span>
              {t.label}
            </NavLink>
          ))}
        </nav>

        <div className="account-content">
          <Outlet />
        </div>
      </div>
    </section>
  );
}
